/**
 * Created by fgallucci on 17/06/2020.
 */

import React, { useCallback } from 'react'
import { isNull } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import LoginComponent from '@ublique/components/Login'
import withStore from 'hoc/withStore'
import useRedirect from 'services/auth/useRedirect'
import useI18nControls from 'hooks/useI18nControls'
import { login, type } from './actions'
import LoginKC from './components/LoginKC'
import { LOGIN_KEYCLOAK_OAUTH2 } from './constants'

function Login({
  user,
  languagesMenuConfig,
  fallbackRedirectPath,
  forceRedirectPath
}) {
  const { t } = useTranslation(['Login', 'Common'])

  const i18nControls = useI18nControls(languagesMenuConfig)

  const redirect = useRedirect({
    fallbackPath: fallbackRedirectPath,
    forceRedirectPath
  })

  const mapErrorToString = useCallback(
    (errorCode) => (errorCode ? t(`Errors.${errorCode}`) : undefined),
    [t]
  )
  if (type === LOGIN_KEYCLOAK_OAUTH2) {
    return <LoginKC login={login} user={user} redirect={redirect} />
  } else {
    if (user) {
      return !isNull(redirect) ? <Redirect to={redirect} /> : null
    }

    return (
      <LoginComponent
        submit={login}
        title={t('Title')}
        submitText={t('Submit')}
        usernameLabel={t('UsernameLabel')}
        passwordLabel={t('PasswordLabel')}
        errorTitle={t('Login:WrongAuthentication')}
        mapErrorToString={mapErrorToString}
        i18nControls={i18nControls}
        showPasswordLabel={t('showPasswordLabel')}
        hidePasswordLabel={t('hidePasswordLabel')}
      />
    )
  }
}

export default withStore(Login, ['user'])
